<template>
  <div class="filter notranslate">
    <div class="tags">
      <div class="tagBox" id="tagBox">
        <div class="tag"
          :class="{ active : this.$route.name === 'localinfo' }"
          :id="this.$route.name === 'localinfo'? 'active' : null"
          @click="changeType('Home')"
          :data-tag="'Home'">
            {{typeToLocale('Home')}}
        </div>
        <div class="tag"
          v-for="type in list"
          :key="type"
          :class="{ active : isActive(type) }"
          :id="isActive(type)? 'active' : null"
          @click="changeType(type)"
          :data-tag="type">
            {{typeToLocale(type)}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocalType',
  props: [
    'locale',
    'lang',
    'list'
  ],
  watch: {
    $route (to, from, next) {
      this.checkType()
    }
  },
  updated () {
    this.changeX()
  },
  mounted () {
    this.checkType()
    this.changeX()
  },
  methods: {
    changeX () {
      const active = document.getElementById('active')
      let scrollX = active === null ? 0 : active.offsetLeft
      document.getElementById('tagBox').scrollLeft = scrollX - 30
    },
    changeType (type) {
      if (type === 'Home') this.$router.push({ name: 'localinfo', params: { ln: this.$route.params.ln } })
      else this.$router.replace({ name: 'filteredLocalinfo', params: { type: type } })
    },
    checkType () {
      const types = this.list
      const type = this.$route.params.type
      const hasType = types.includes(type)
      if (!hasType) {
        this.$router.push({ name: 'localinfo', params: { ln: this.$route.params.ln } })
      }
    },
    typeToLocale (type) {
      type = `localinfo_${type}`
      return this.locale[type]
    },
    isActive (type) {
      return this.$route.params.type === type
    }
  }
}
</script>

<style lang="scss" scoped>
.tags {
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid $color-lgrey2;
  background-color: $color-white;
  box-shadow: 0 0 10px rgba(0,0,0,0.15);
}
.tagBox {
  padding: 8px 15px;
  white-space: nowrap;
  overflow: auto;
}
.tag {
  display: inline-block;
  margin-right: 4px;
  padding: 0.2em 1em;
  vertical-align: top;
  font-size: 14px;
  color: $color-grey;
  border: 1px solid $color-lgrey2;
  border-radius: 50px;
  width: auto;
}

.active{
  color: $color-white;
  border-color: $color-green;
  background-color: $color-green;
}
</style>
